import { Box, Button, Flex, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, VStack, useToast } from '@chakra-ui/react';
import React from 'react';
import AdminHelpers from '../../../services/admin/admin.service';

export const DeleteCourseModal: React.FC<any> = ({ 
    courseId, 
    isOpenDelete, 
    onCloseDelete, 
    updateRecord }: 
    { courseId: string,
    isOpenDelete :any ,
    onCloseDelete:any, 
    updateRecord:any}) => {
    const toast = useToast();

//   const { isOpen, onOpen, onClose } = useDisclosure();
    // const cancelRef = useRef().current;

    const handleDeleteCourse = async (courseId:string) => {
        try{
            const deleteCourse = await AdminHelpers.deleteCourse(courseId)
            if (deleteCourse) {
                onCloseDelete();
                updateRecord();
                toast({
                    title: "Delete Course",
                    description: "Course deleted successfully",
                    status: "success",
                })
            }else{
                toast({
                    title: "Delete Course",
                    description: `${deleteCourse.message}`,
                    status: "success",
                }) 
            }
        }catch (error) {
            toast({
                title: "Delete Course",
                description: "Something went wrong, try again later",
                status: "error",
            })
        }
    }

  return (
      <>
        <Modal
            isOpen={isOpenDelete}
            onClose={onCloseDelete}
            scrollBehavior="outside"
            closeOnOverlayClick={true}
            size="md"
            isCentered
        >
            <ModalOverlay />
            <ModalContent borderRadius={5} px={3}>
                <ModalHeader>
                    <Flex justifyContent='center'>
                        <Box>
                            <Flex justifyContent='center'>
                                <Text mx='auto' color="#353535" fontSize="22px" fontWeight='800'>
                                    Delete Course
                                </Text>
                            </Flex>
                        </Box>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton size="sm" />
                <ModalBody>
                    <VStack>
                        <Text fontWeight={'700'} fontSize='16px'>
                            Are you sure you want to delete this course ?
                        </Text>
                        <HStack
                            gap="1rem"
                            fontSize='13px'
                            justifyContent={'flex-end'}
                            width={'100%'}
                            paddingY={'1rem'}
                        >
                            <Button onClick={() => handleDeleteCourse(courseId)}
                                colorScheme='red'
                                borderRadius={'none'}
                            >Delete</Button>
                            <Button
                                borderRadius={'none'}
                                onClick={onCloseDelete}
                            >Exit</Button>
                        </HStack>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
      </>
  )
};